import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { adminApi } from '../../api';
import { toast } from '../../hooks/use-toast';
import { Ban, CheckCircle2, DollarSign } from 'lucide-react';

const UsersAdmin = () => {
  const { users, refreshAll } = useAdmin();
  const [q, setQ] = useState('');
  const list = users.filter((u) => !q.trim() || u.username.toLowerCase().includes(q.toLowerCase()) || (u.display_name || '').toLowerCase().includes(q.toLowerCase()));

  const toggleBan = async (u) => {
    try {
      await adminApi.updateUser(u.id, { banned: !u.banned });
      toast({ title: u.banned ? 'User unbanned' : 'User banned' });
      refreshAll();
    } catch (e) { toast({ title: 'Failed' }); }
  };

  const adjustBalance = async (u) => {
    const cur = window.prompt('Currency? (usdt / inr)', 'usdt');
    if (!cur || !['usdt', 'inr'].includes(cur.toLowerCase())) return;
    const amt = window.prompt(`Amount to add/subtract (${cur.toUpperCase()}) — negative to deduct:`, '0');
    if (amt === null) return;
    const n = Number(amt);
    if (!n) return;
    const body = cur.toLowerCase() === 'usdt' ? { usdt_delta: n } : { inr_delta: n };
    try {
      await adminApi.updateUser(u.id, body);
      toast({ title: 'Balance adjusted', description: `${n > 0 ? '+' : ''}${n} ${cur.toUpperCase()}` });
      refreshAll();
    } catch (e) { toast({ title: 'Failed' }); }
  };

  return (
    <div className="px-8 py-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">USERS</div>
          <div className="text-2xl text-[#e6e6e6] font-mono">{list.length}</div>
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="search username…" className="bg-[#0a0a0a] border border-[#1f1f1f] rounded-md px-3 py-2 text-[12px] text-[#e6e6e6] font-mono outline-none focus:border-[#22c55e] w-[240px]" />
      </div>

      <div className="border border-[#151515] rounded-md overflow-hidden font-mono">
        <div className="grid grid-cols-[140px_1fr_1fr_1fr_1fr_1fr_140px] px-4 py-3 text-[10px] tracking-[0.25em] text-[#5a5a5a] border-b border-[#151515] bg-[#080808]">
          <div>USER ID</div>
          <div>USERNAME</div>
          <div>DISPLAY NAME</div>
          <div>USDT</div>
          <div>INR</div>
          <div>JOINED</div>
          <div className="text-right">ACTIONS</div>
        </div>
        {list.length === 0 && <div className="px-4 py-8 text-center text-[12px] text-[#5a5a5a]">No users.</div>}
        {list.map((u) => (
          <div key={u.id} className="grid grid-cols-[140px_1fr_1fr_1fr_1fr_1fr_140px] px-4 py-3 text-[12px] border-b border-[#0f0f0f] last:border-0 items-center hover:bg-[#0d0d0d]">
            <div className="text-[#22c55e] truncate pr-2">{u.id}</div>
            <div className="text-[#e6e6e6]">@{u.username} {u.banned && <span className="text-[9px] px-1 py-0.5 rounded bg-[#ef4444]/20 text-[#ef4444] ml-1">BANNED</span>}</div>
            <div className="text-[#8a8a8a]">{u.display_name}</div>
            <div className="text-[#e6e6e6]">${Number(u.usdt || 0).toFixed(2)}</div>
            <div className="text-[#e6e6e6]">₹{Number(u.inr || 0).toFixed(2)}</div>
            <div className="text-[#8a8a8a] text-[11px]">{u.created_at}</div>
            <div className="text-right flex justify-end gap-1">
              <button onClick={() => adjustBalance(u)} title="Adjust balance" className="p-1.5 rounded border border-[#1f1f1f] text-[#22c55e] hover:bg-[#0f1a12]"><DollarSign size={12} /></button>
              <button onClick={() => toggleBan(u)} title={u.banned ? 'Unban' : 'Ban'} className={`p-1.5 rounded border border-[#1f1f1f] ${u.banned ? 'text-[#22c55e] hover:border-[#22c55e]' : 'text-[#8a8a8a] hover:border-[#ef4444] hover:text-[#ef4444]'}`}>
                {u.banned ? <CheckCircle2 size={12} /> : <Ban size={12} />}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsersAdmin;
